<template>
  <q-form class="q-col-gutter-y-sm">
    <q-input
      v-model="name"
      bg-color="accent"
      filled
      label-color="black"
      :label="$t('catering.form.name')"
      lazy-rules
      :rules="[
        val => val && val.length > 0 || $t('catering.form.errors.name')
      ]"
      @blur="updateUser"
    />

    <q-input
      v-model="email"
      bg-color="accent"
      filled
      type="email"
      label-color="black"
      :label="$t('catering.form.email')"
      :rules="[
        val => val && val.length > 0 || $t('email.errors.email'),
        () => validateEmail() || $t('email.errors.emailInvalid')
      ]"
      @blur="updateUser"
    />

    <q-input
      v-model="phone"
      class="q-input__phone"
      bg-color="accent"
      filled
      type="tel"
      label-color="black"
      :label="$t('catering.form.phone')"
      lazy-rules
      :rules="[
        val => val && val.length > 0 || $t('catering.form.errors.phone')
      ]"
      @blur="updateUser"
    />

    <q-input
      v-model="comment"
      bg-color="accent"
      filled
      label-color="black"
      type="textarea"
      :label="$t('catering.form.comment')"
      @blur="updateUser"
    />
  </q-form>
</template>

<script>
export default {
  name: 'CateringUser',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      comment: '',
    };
  },

  methods: {
    updateUser() {
      if (this.isValid()) {
        this.$emit('update', {
          name: this.name ?? '',
          email: this.email ?? '',
          phone: this.phone ?? '',
          comment: this.comment ?? '',
        });
      }
    },

    isValid() {
      return this.name.length > 0
        && this.validateEmail()
        && this.phone.length > 0;
    },

    validateEmail() {
      if (this.email === '') {
        return true;
      }

      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.email);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.q-field__control) {
  border-radius: 0;
}
:deep(.q-input__phone .q-field__inner) {
  max-width: 203px;
}
</style>
